// @flow
import React from "react"
import { connect } from "react-redux"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import Text from "@kiwicom/orbit-components/lib/Text"
import styled from "styled-components"

import RadioButtons from "common/components/RadioButtons/RadioButtons"
import { toggleOption } from "common/services/options/actions"

type Mode = {
  value: string,
  label: string,
}

type Props = {
  handleChange: () => void,
  label: string,
  modes: Array<Mode>,
  active: number | string,
}

const TextWrapper = styled.div`
  width: 50%;
`

const OptionToggleBtns = (props: Props) => (
  <Stack direction="row" justify="between">
    <TextWrapper>
      <Text>{`${props.label}: `}</Text>
    </TextWrapper>
    <RadioButtons {...props} />
  </Stack>
)

// $FlowFixMe TODO: plz add type when updating
export default connect(
  (state, ownProps) => {
    const optionState = state.options.get(ownProps.option)
    const active = ownProps.checkActive ? ownProps.checkActive(optionState) : optionState
    return {
      active: active ? "enabled" : "disabled",
    }
  },
  (dispatch, ownProps) => ({
    handleChange: () => {
      dispatch(toggleOption(ownProps.option))
      if (ownProps.handleChange) {
        ownProps.handleChange(dispatch)
      }
    },
  }),
)(OptionToggleBtns)
